import React, { useId } from 'react';
import { StyledButtonGroupContainer } from './index.styles.js';
import {} from '../text-link/index.js';
import {} from '../text-button/index.js';
import {} from '@oneaudi/unified-web-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const ButtonGroup = ({ className, children, orientation = 'horizontal', mode = 'fill', margin, ...rest }) => {
    const id = useId();
    const containsIconButton = React.Children.toArray(children).some((child) => {
        return (React.isValidElement(child) &&
            child.props.children === undefined &&
            child.props.icon !== undefined &&
            ['primary', 'secondary', 'tertiary'].includes(child.props.variant));
    });
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const roleProp = a11yProps.role ?? 'group';
    return (React.createElement(StyledButtonGroupContainer, { className: className, "$orientation": orientation, "$mode": mode, containsIconButton: containsIconButton, margin: margin, ...a11yProps, ...dataProps, role: roleProp }, children.slice(0, 3).map((item, i) => {
        if (React.isValidElement(item) && item.props.children !== undefined) {
            return (React.createElement(React.Fragment, { key: i + id }, React.cloneElement(item, {
                isFullWidth: mode === 'fill' ? true : false
            })));
        }
        return React.createElement(React.Fragment, { key: i + id }, item);
    })));
};
//# sourceMappingURL=index.js.map